import { Controller } from "@hotwired/stimulus"

// Intercepts mute clicks on notifications and shows a confirmation modal
// naming the category the user is about to silence. "Don't show this again"
// persists a user preference so the modal is skipped afterward.
//
// The mute link must NOT carry method: :patch / data-turbo-method, otherwise
// Turbo/UJS submits the request on click before the modal can show.
// This controller fires the PATCH itself (see muteFromLink).
export default class extends Controller {
  static targets = ["modal", "checkbox", "title", "body"]
  static values = { skip: Boolean, preferencePath: String }

  connect() {
    this.pendingLink = null
  }

  prompt(event) {
    event.preventDefault()
    const link = event.currentTarget

    if (this.skipValue) {
      this.muteFromLink(link)
      return
    }

    this.pendingLink = link
    if (this.hasCheckboxTarget) this.checkboxTarget.checked = false
    this.applyCategoryCopy(link.dataset.categoryLabel)
    $(this.modalTarget).modal('show')
  }

  confirm() {
    if (this.hasCheckboxTarget && this.checkboxTarget.checked) {
      this.skipValue = true
      this.savePreference()
    }
    $(this.modalTarget).modal('hide')

    const link = this.pendingLink
    this.pendingLink = null
    if (link) this.muteFromLink(link)
  }

  applyCategoryCopy(label) {
    const name = label || "this category"
    if (this.hasTitleTarget) {
      this.titleTarget.textContent = `Mute ${name} notifications?`
    }
    if (this.hasBodyTarget) {
      this.bodyTarget.textContent =
        `You will no longer receive in-app ${name} notifications.`
    }
  }

  muteFromLink(link) {
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    fetch(link.href, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': token,
        'Accept': 'text/vnd.turbo-stream.html'
      }
    }).then(resp => resp.text()).then(html => {
      if (window.Turbo && html) window.Turbo.renderStreamMessage(html)
    }).catch(err => console.error('mute-confirm request failed', err))
  }

  savePreference() {
    const path = this.preferencePathValue
    if (!path) return
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const formData = new FormData()
    formData.append('preference[hide_mute_confirmation]', '1')
    formData.append('_method', 'patch')
    if (token) formData.append('authenticity_token', token)
    fetch(path, { method: 'POST', body: formData })
      .catch(err => console.error('mute-confirm preference save failed', err))
  }
}
